import { fromJS, Map } from 'immutable';
import { mergeWithVersions } from './merger';

export function createEventsMap(events) {
    const result = {};
    events.forEach(event => {
        result[event.id] = fromJS(event);
    });
    return Map(result);
}

export function createEventsMapForScoreboard(events) {
    const result = {};
    events.forEach(event => {
        result[event.match.id] = fromJS(event);
    });

    return Map(result);
}

function matchCreated(actualMap, data) {
    console.log('match created ', data);
    return actualMap.setIn([data.event.id.toString()], fromJS(data.event));
}

function matchDeleted(actualMap, data) {
    console.log('match deleted ', data);
    return actualMap.deleteIn([data.event.id.toString()]);
}

function matchUpdated(actualMap, data) {
    return actualMap.updateIn([data.event.id.toString()], old => {
        if (old) {
            return mergeWithVersions(old, fromJS(data.event));
        } else {
            return old;
        }
    });
}

export function pushEvent2Map(
    actualMap,
    msg,
    matchCreatedHandler = matchCreated,
    matchDeletedHandler = matchDeleted,
    matchUpdatedHandler = matchUpdated
) {
    if (!msg) {
        return actualMap;
    }

    let resultMap = actualMap;

    const payload = msg.payload,
        data = msg.data,
        event = msg.payloadEvent;

    if (payload === 'MATCH' && data) {
        if (event === 'CREATED' && matchCreatedHandler) {
            resultMap = matchCreatedHandler(actualMap, data);
        } else if (data.event) {
            if (event === 'DELETED' && matchDeletedHandler) {
                resultMap = matchDeletedHandler(actualMap, data);
            } else if (event === 'CHANGED' && matchUpdatedHandler) {
                resultMap = matchUpdatedHandler(actualMap, data);
            }
        }
    } else if (payload === 'BET') {
    } else {
        console.trace('unknown message', JSON.stringify(msg));
    }

    return resultMap;
}
